import { Injectable } from "@angular/core";
import { ApiService } from "@meddatacore/common";
import { Observable } from "rxjs";
import { AppointmentStatus } from "../../enums";
import { AppointantAppointmentRequest, 
    Appointment, 
    AppointmentRequest, 
    AttendanceAppointmentRequest, 
    AttendancesAppointmentsRequest, 
    AttendancesAppointmentsInPeriodRequest 
} from "../../models";

@Injectable({ providedIn: 'root' })
export class AppointmentService extends ApiService {
    endPoint = '/api/appointment';
    create(model: Appointment): Observable<string> {
        return this.http.post<string>(`${this.appointmentBaseURL}${this.endPoint}`, model);
    }

    update(model: Appointment): Observable<string> {
        return this.http.put<string>(`${this.appointmentBaseURL}${this.endPoint}`, model);
    }

    getList(request: AppointmentRequest): Observable<Appointment[]> {
        return this.http.post<Appointment[]>(`${this.appointmentBaseURL}${this.endPoint}/list`, request);
    }

    get(id: string): Observable<Appointment> {
        return this.http.get<Appointment>(`${this.appointmentBaseURL}${this.endPoint}/${id}`);
    }

    delete(id: string): Observable<any> {
        return this.http.delete<any>(`${this.appointmentBaseURL}${this.endPoint}/${id}`);
    }

    getAttendanceAppointments(request: AttendanceAppointmentRequest): Observable<Appointment> {
        return this.http.post<Appointment>(`${this.appointmentBaseURL}${this.endPoint}/attendance/appointments`, request);
    }

    getAppointantAppointments(request: AppointantAppointmentRequest): Observable<Appointment[]> {
        return this.http.post<Appointment[]>(`${this.appointmentBaseURL}${this.endPoint}/appointant/appointments`, request);
    }

    getAttendancesAppointments(request: AttendancesAppointmentsRequest): Observable<Appointment[]> {
        return this.http.post<Appointment[]>(`${this.appointmentBaseURL}${this.endPoint}/attendances/appointments`, request);
    }

    updateAppointmentStatus(id: string, status: AppointmentStatus) {
        return this.http.put<Appointment>(`${this.appointmentBaseURL}${this.endPoint}/${id}/status/${status}`, {});
    }

    confirmAppointment(id: string) {
        return this.http.get<Appointment>(`${this.appointmentBaseURL}${this.endPoint}/${id}/confirm`);
    }
    getAttendancesAppointmentsInPeriod(request: AttendancesAppointmentsInPeriodRequest): Observable<Appointment[]> {
        return this.http.post<Appointment[]>(`${this.appointmentBaseURL}${this.endPoint}/attendances/appointments/in-period`, request);
    }
}
